
// SVG Icon: play-inverted
export default { id: "terriajs-play-inverted" };
export const id = "terriajs-play-inverted";
export const name = "play-inverted";
